/**
 * ****************************************************************************
 * @description     :   Main component for page APP_WorkReport001
 * @created at      :   2025/09/26
 * @created by      :   ANS901 – hainn@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

const dataInit = {
    company: '',
    department_cd: '',
    department_name: '',
    client_cd: '',
    client_nm: '',
    sale_representative_cd: '',
    sale_representative_nm: '',
    reporting_date_start: '',
    reporting_date_end: ''
};

export default {
    namespaced: true,
    state: {
        data: { ...dataInit },
        selectOptionKey: ['id', 'content'],
        searchData: [],
        options: {
            company: [
                {
                    id: '0',
                    content: ''
                },
                {
                    id: '1',
                    content: 'ムーヴ'
                }
            ],
            department: [
                {
                    id: '0',
                    content: ''
                },
                {
                    id: '1',
                    content: 'ムーヴ'
                }
            ],
            office: [
                {
                    code: '1',
                    content: '新宿オフィス'
                },
                {
                    code: '2',
                    content: '新宿オフィス2'
                }
            ],
            type: [
                {
                    id: '1',
                    content: '現場'
                },
                {
                    id: '2',
                    content: 'オフィス'
                }
            ],
            title: [
                {
                    id: '1',
                    content: '公休'
                }
            ],
            message: [
                {
                    code: '0',
                    name: '未'
                },
                {
                    code: '1',
                    name: '済'
                }
            ],
            workday_number: [{ id: '1', content: '1' }]
        },
        paginationData: {
            pageNo: 1,
            pageSize: 10,
            totalRows: 0,
            msgNoData: '該当するデータが存在しません。'
        }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.paginationData.pageNo = 1;
            state.paginationData.pageSize = 10;
            state.paginationData.totalRows = 0;
            state.paginationData.msgNoData = '該当するデータが存在しません。';
            state.searchData = [];
        },
        setSearchData(state, data) {
            state.searchData = data ?? [];
        },
        setPageNavigation(state, data) {
            state.paginationData.pageNo = parseInt(data.page);
            state.paginationData.pageSize = parseInt(data.pageSize);
            state.paginationData.totalRows = parseInt(data.totalRows);
            state.paginationData.msgNoData = parseInt(data.totalRows) == 0 ? '該当するデータが存在しません。' : '';
        }
    },
    actions: {}
};
